// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import PostTile from 'church-theme-library/components/PostTile/PostTile'
import { get } from 'church-theme-library/utilities/objects'

class ImageLinks extends React.Component {
	render() {
		const { translate, contentId, sectionId, data } = this.props
		const columns = parseInt( get( ['settings', 'columns'] )( data, '' ), 10 )
		const className = `section-image-links with-columns-${columns}`

		const fullData = {
			image_1: data.image_1 || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				width: '',
				height: '',
				thumb: '',
				srcset: ''
			},
			image_2: data.image_2 || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				width: '',
				height: '',
				thumb: '',
				srcset: ''
			},
			image_3: data.image_3 || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				width: '',
				height: '',
				thumb: '',
				srcset: ''
			},
			image_4: data.image_4 || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				width: '',
				height: '',
				thumb: '',
				srcset: ''
			},
			link_1: data.link_1 || {
				url: '',
				text: ''
			},
			link_2: data.link_2 || {
				url: '',
				text: ''
			},
			link_3: data.link_3 || {
				url: '',
				text: ''
			},
			link_4: data.link_4 || {
				url: '',
				text: ''
			},
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-item">
						<PostTile
							url={ fullData.link_1.url }
							title={ fullData.link_1.text }
							image={ fullData.image_1 }
							imageAlt={ fullData.link_1.text }
							direction="vertical"
							size="medium"
							order="image-text"
							allowAspectRatio={ true }
							editableImageData={ {
								id: contentId,
								sectionId: sectionId,
								sectionType: data.type,
								sectionDataId: 'image_1'
							} }
							editableTextData={ {
								id: contentId,
								sectionId: sectionId,
								sectionType: data.type,
								sectionDataId: 'link_1',
								linkUrl: fullData.link_1.url,
								linkText: fullData.link_1.text,
								message: translate( 'Click to set link' )
							} }
						/>
					</div>

					<div className="-item">
						<PostTile
							url={ fullData.link_2.url }
							title={ fullData.link_2.text }
							image={ fullData.image_2 }
							imageAlt={ fullData.link_2.text }
							direction="vertical"
							size="medium"
							order="image-text"
							allowAspectRatio={ true }
							editableImageData={ {
								id: contentId,
								sectionId: sectionId,
								sectionType: data.type,
								sectionDataId: 'image_2'
							} }
							editableTextData={ {
								id: contentId,
								sectionId: sectionId,
								sectionType: data.type,
								sectionDataId: 'link_2',
								linkUrl: fullData.link_2.url,
								linkText: fullData.link_2.text,
								message: translate( 'Click to set link' )
							} }
						/>
					</div>

					{ columns > 2 &&
						<div className="-item">
							<PostTile
								url={ fullData.link_3.url }
								title={ fullData.link_3.text }
								image={ fullData.image_3 }
								imageAlt={ fullData.link_3.text }
								direction="vertical"
								size="medium"
								order="image-text"
								allowAspectRatio={ true }
								editableImageData={ {
									id: contentId,
									sectionId: sectionId,
									sectionType: data.type,
									sectionDataId: 'image_3'
								} }
								editableTextData={ {
									id: contentId,
									sectionId: sectionId,
									sectionType: data.type,
									sectionDataId: 'link_3',
									linkUrl: fullData.link_3.url,
									linkText: fullData.link_3.text,
									message: translate( 'Click to set link' )
								} }
							/>
						</div>
					}

					{ columns > 3 &&
						<div className="-item">
							<PostTile
								url={ fullData.link_4.url }
								title={ fullData.link_4.text }
								image={ fullData.image_4 }
								imageAlt={ fullData.link_4.text }
								direction="vertical"
								size="medium"
								order="image-text"
								allowAspectRatio={ true }
								editableImageData={ {
									id: contentId,
									sectionId: sectionId,
									sectionType: data.type,
									sectionDataId: 'image_4'
								} }
								editableTextData={ {
									id: contentId,
									sectionId: sectionId,
									sectionType: data.type,
									sectionDataId: 'link_4',
									linkUrl: fullData.link_4.url,
									linkText: fullData.link_4.text,
									message: translate( 'Click to set link' )
								} }
							/>
						</div>
					}
				</div>
			</div>
		)
	}
}

export default localize( ImageLinks )
